import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Query } from 'graphql-models';
import meQuery from 'walden-trace-app/graphql/user/me.graphql';
import type ApiService from 'walden-trace-app/services/api';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppUserSettingsModel = Resolved<ReturnType<AppUserSettingsRoute['model']>>;

export default class AppUserSettingsRoute extends Route {
  @service('api') declare apiService: ApiService;

  async model() {
    const { me } = await this.apiService.query<{ me: Query['me'] }>({
      query: meQuery,
    });

    if (!me) {
      throw new Error('User not found');
    }

    return { user: me };
  }
}
